
import classNames from 'classnames';
import { parseAsArrayOf, parseAsStringEnum, useQueryState } from 'nuqs';

import type {
  RewardPoolDistributionPolicy} from '@shared/api/types/rewardPools';
import {
  REWARD_POOL_DISTRIBUTION_POLICY
} from '@shared/api/types/rewardPools';

export const REWARD_POOLS_POLICY_ALL_FILTER = 'ALL';

export type RewardPoolsPolicyFilterType =
  | RewardPoolDistributionPolicy
  | typeof REWARD_POOLS_POLICY_ALL_FILTER;

export const DEFAULT_POOLS_POLICY_FILTER_VALUE: RewardPoolsPolicyFilterType[] = [
  REWARD_POOLS_POLICY_ALL_FILTER,
];

export const policyFiltersInOrder: {
  id: RewardPoolsPolicyFilterType;
  label: string;
  filters: RewardPoolsPolicyFilterType[];
}[] = [
  {
    id: REWARD_POOLS_POLICY_ALL_FILTER,
    filters: [REWARD_POOLS_POLICY_ALL_FILTER],
    label: 'All',
  },
  {
    id: REWARD_POOL_DISTRIBUTION_POLICY.FCFS,
    filters: [REWARD_POOL_DISTRIBUTION_POLICY.FCFS, REWARD_POOL_DISTRIBUTION_POLICY.FCFS_V2],
    label: 'FCFS',
  },
  {
    id: REWARD_POOL_DISTRIBUTION_POLICY.PRO_RATA_KARMA,
    filters: [
      REWARD_POOL_DISTRIBUTION_POLICY.PRO_RATA_KARMA,
      REWARD_POOL_DISTRIBUTION_POLICY.PRO_RATA_SWAP,
    ],
    label: 'Pro-Rata',
  },
  {
    id: REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE,
    filters: [REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE, REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE_V2],
    label: 'Raffle',
  },
];

export const useRewardPoolsDistributionPolicyFilterQueryState = () => {
  const validValues = policyFiltersInOrder.flatMap(({ filters }) => filters);

  return useQueryState(
    'distributionPolicies',
    parseAsArrayOf(parseAsStringEnum(validValues))
      .withDefault(DEFAULT_POOLS_POLICY_FILTER_VALUE)
      .withOptions({
        clearOnDefault: true,
      }),
  );
};

export const DistributionPolicyFilter = () => {
  const [filters, setFilters] = useRewardPoolsDistributionPolicyFilterQueryState();

  return (
    <div className="toggle-button-group">
      {policyFiltersInOrder.map(({ id, label, filters: _filters }) => {
        const isActive = filters?.includes(id) ?? false;

        return (
          <button
            onClick={() => setFilters(_filters)}
            key={id}
            className={classNames('toggle-button', {
              'toggle-button-active': isActive,
            })}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};
